import { CustomElement } from '@aurelia/runtime-html';
import "./popover.scss";
export const name = "popover";
export const template = "<template>\n  <button type=\"button\" class=\"popover-button\" id.to-view=\"idvalue\" data-bs-toggle=\"popover\" data-bs-content.to-view=\"content\" click.trigger=\"iconClick($event)\" tabindex=\"-1\">\n  <i class=\"far fa-question-circle fa-lg\"></i>\n</button>\n</template>\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
